import React, { Fragment, useContext, useEffect } from "react";

import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { Breadcrumbs, Btn } from "../../../AbstractElements";

import { ContatcCharges, Entities } from "../../../Shared/Constants";

import TableSearch from "../../../Shared/Components/Search/TableSearch";

import { PlusCircle } from "react-feather";

import DistrictForm from "./DistrictForm";
import DistrictContext from "./ContextProvider";
import DataTableComponent from "./DataTableComponent";
import { hasPermission } from "../../../Shared/Utils/userUtils";

const DistrictList = () => {
  const { modalTogle, setItem, setSearchTerm } = useContext(DistrictContext);
  const handleNew = (row) => {
    setItem({});
    modalTogle();
  };

  useEffect(() => {
    return () => {
      setSearchTerm("");
    };
  }, []);

  return (
    <Fragment>
      <Breadcrumbs parent="Admin" title={Entities} mainTitle={"Distritos"} />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody className="data-tables">
                <Row className="project-list">
                  <Col md="4">
                    <TableSearch onSearch={setSearchTerm} />
                  </Col>
                  <Col sm="8" className="p-0">
                    {hasPermission("create_list") ? (
                      <div className="text-end">
                        <Btn
                          attrBtn={{
                            color: "primary",
                            className: "btn btn-primary text-white",
                            onClick: handleNew,
                          }}
                        >
                          <PlusCircle />
                          Nuevo Distrito
                        </Btn>
                        <DistrictForm />
                      </div>
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col md="12">
                    <DataTableComponent />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default DistrictList;
